import DefaultActionTypes from "./action-types";

export const setClosePacienteModal = (payload) => ({
    type: DefaultActionTypes.CLOSE_PACIENTE_MODAL,
    payload,
});

export const setInitCall = (payload) => ({
    type: DefaultActionTypes.INIT_CALL,
    payload,
});

export const setOpenChatAssistente = (payload) => ({
    type: DefaultActionTypes.OPEN_CHAT_ASSISTENTE,
    payload,
});

export const setFullScreenPacModal = (payload) => ({
    type: DefaultActionTypes.FULL_SCREEN_PACIENTE_MODAL,
    payload,
});